import urls from '../api_urls/messageCenter'
import { _post } from '@/axios/request'

// 未读消息数
export function getUnreadMessageCount (params) {
  return _post(urls.getSimpleMessageCount, params)
}
// 用户消息列表
export function getMessageList (params) {
    return _post(urls.getSimpleMessageList, params)
}
// 未读点击变成已读
export function getMessageRead (params) {
    return _post(urls.clickSimpleMessage, params)
}
// 发送消息
export function sendMessage (params) {
    return _post(urls.sendMessage, params)
}


// WEBPACK FOOTER //
// ./src/axios/api/messageCenter.js